export const page = 0;
export const pageSize = 20;
export const pageSizeOptions = [
  { label: "20", value: 20 },
  { label: "50", value: 50 },
  { label: "100", value: 100 },
];

export default {
  page,
  pageSize,
  pageSizeOptions
};